const { BASE_URL, IMAGE_URL, FILE_URL } = require('./_config_' + process.env.NODE_ENV)

export const IMAGE_BASE_URL = IMAGE_URL
export const SERVER_BASE_URL = BASE_URL
export const FILE_BASE_URL = FILE_URL

export const HTTP_TYPE_GET = 'GET'
export const HTTP_TYPE_POST = 'POST'

export const Menu = {
  None: 'none',
  Home: 'home',
  Company: 'company',
  Demand: 'demand',
  Supply: 'supply',
  Case: 'case',
  About: 'about',
  User: {
    PublishDemand: 'publishDemand',
    PublishSupply: 'publishSupply',
    MyPublish: 'myPublish',
    MyCollect: 'myCollect',
    MyDocking: 'myDocking',
    MyIntention: 'myIntention',
    MyMessage: 'myMessage',
    MyProfile: 'myProfile',
    MyFile: 'myFile'
  }
}

export const STORAGE = {
  LOGIN_USER: 'LOGIN_USER',
  LANGUAGE: 'LANGUAGE'
}

export const Trade = {
  Demand: 'trade_demand',
  Supply: 'trade_supply',
  Status: {
    Tendering: 'trade_tendering',
    Verify: 'trade_verify',
    UnderCarriage: 'trade_under_carriage'
  },
  UserRole: {
    Publisher: 1, // 发布人
    Docker: 2, // 对接人
    Other: 3 // 其他
  }
}

export const Duty = {
  Buyer: 1,
  Seller: 2
}



// WEBPACK FOOTER //
// ./src/util/constants.js